<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc"><h1>CONTENTS</h1>
<ol>
<li><a href="#/Text/fm1">Epigraph</a></li>
<li><a href="#/Text/pic">These be the Facts</a></li>
<li><a href="#/Text/Chapter01">One</a></li>
<li><span href="#/Text/Chapter02" title="Link target outside of Sample">Two</span></li>
<li><span href="#/Text/Chapter03" title="Link target outside of Sample">Three</span></li>
<li><span href="#/Text/Chapter04" title="Link target outside of Sample">Four</span></li>
<li><span href="#/Text/Chapter05" title="Link target outside of Sample">Five</span></li>
<li><span href="#/Text/Chapter06" title="Link target outside of Sample">Six</span></li>
<li><span href="#/Text/Chapter07" title="Link target outside of Sample">Seven</span></li>
<li><span href="#/Text/Chapter08" title="Link target outside of Sample">Eight</span></li>
<li><span href="#/Text/Chapter09" title="Link target outside of Sample">Nine</span></li>
<li><span href="#/Text/Chapter10" title="Link target outside of Sample">Ten</span></li>
<li><span href="#/Text/Chapter11" title="Link target outside of Sample">Eleven</span></li>
<li><span href="#/Text/Chapter12" title="Link target outside of Sample">Twelve</span></li>
<li><span href="#/Text/Chapter13" title="Link target outside of Sample">Thirteen</span></li>
<li><span href="#/Text/Chapter14" title="Link target outside of Sample">Fourteen</span></li>
<li><span href="#/Text/bm" title="Link target outside of Sample">This Be One More Fact</span></li>
<li><span href="#/Text/readinggroupguide" title="Link target outside of Sample">Reading Group Guide</span></li>
<li><span href="#/Text/acknowledgements" title="Link target outside of Sample">Acknowledgements</span></li>
<li><span href="#/Text/author" title="Link target outside of Sample">About the Author</span></li>
</ol></nav>
<nav epub:type="landmarks" hidden="hidden" id="landmarks"><ol>
<li><span epub:type="cover" href="#/Text/cover" title="Link target outside of Sample">Cover</span></li>
<li><a epub:type="toc" href="#/Text/toc">Contents</a></li>
<li><span epub:type="bodymatter" href="#/Text/dedication" title="Link target outside of Sample">Dedication</span></li>
</ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?28cb3b8e